module.exports = __webpack_public_path__ + "media/images/fundraise/fundraise-img-03-9d355c267dd013eb80bc182b7c9b74c1.jpg";